import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyright"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Footer/FooterCopyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerInitiator"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/GoogleTagManagerInitiator/GoogleTagManagerInitiator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Header/Header.tsx");
